import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TipoFascicolo} from '../../../../../../../common/models/tipologiche/tipo-fascicolo';
import {TipoGenericoRimovibile} from '../../../../../../../common/models/tipologiche/tipo-generico-rimovibile';
import {
  orderCategoria
} from '../../../../../../../common/components/option-component/aggiungiFascicolo/fascicolo-select-modal.component';
import {TipoPratica} from '../../../../../../../common/models/tipologiche/tipo-pratica';
import { CreazionePraticaTipologicheService } from '../../../../services/creazione-pratica-tipologiche.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-tipi-fascicolo-widget',
  templateUrl: './tipi-fascicolo-widget.component.html',
  styleUrls: ['./tipi-fascicolo-widget.component.css']
})
export class TipiFascicoloWidgetComponent implements OnInit {

  @Input() tipoPratica: TipoPratica;
  @Output() tipoFascicoloChange: EventEmitter<TipoFascicolo> = new EventEmitter<TipoFascicolo>()
  listaFascicoliPerCategoria: { categoria: TipoGenericoRimovibile, tipiFascicolo: TipoFascicolo[] }[] = [];

  constructor(private tipologicheService: CreazionePraticaTipologicheService, private router: Router) {
  }

  ngOnInit() {
    this.tipologicheService.getTipiFascicolo(this.tipoPratica.id)
      .subscribe(response =>{
        let tipiPraticaFiltered;
        if(this.router.url.endsWith('consultazione')){
          tipiPraticaFiltered = response.filter(elem => elem.categoria.id === 'ESECUZIONE' || elem.categoria.id === 'GIUDIZIALE');
        } else {
          tipiPraticaFiltered = response
        }
        this.creaListaFascicoliPerCategoria(tipiPraticaFiltered.sort((a, b): number => {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        })
      )
      })

  }

  creaListaFascicoliPerCategoria(listaTipiFascicolo: TipoFascicolo[]) {
    this.listaFascicoliPerCategoria = [];
    for (const tipoFascicolo of listaTipiFascicolo) {
      let founded = false;
      for (const categoriaTipiFascicoli of this.listaFascicoliPerCategoria) {
        if (categoriaTipiFascicoli.categoria.id === tipoFascicolo.categoria.id) {
          categoriaTipiFascicoli.tipiFascicolo.push(tipoFascicolo);
          founded = true;
        }
      }
      if (!founded) {
        const nuovaCategoriaTipiFascicolo: { categoria: TipoGenericoRimovibile, tipiFascicolo: TipoFascicolo[] } = {
          categoria: tipoFascicolo.categoria,
          tipiFascicolo: [tipoFascicolo]
        };
        this.listaFascicoliPerCategoria.push(nuovaCategoriaTipiFascicolo);
      }
    }

    this.listaFascicoliPerCategoria.sort((a, b): number => {
      if (orderCategoria[a.categoria.label] < orderCategoria[b.categoria.label]) {
        return -1;
      }
      if (orderCategoria[a.categoria.label] > orderCategoria[b.categoria.label]) {
        return 1;
      }
      return 0;
    });
  }

  setTipoFascicolo(tipoFascicolo: TipoFascicolo) {
    this.tipoFascicoloChange.emit(tipoFascicolo);
  }
}
